export default indexRun;

function indexRun($rootScope, $state, $timeout, APIConfig, appModel, appServices, watchdog) {
  "ngInject";

  /* HTTP Code 401 handling */
  $rootScope.$on('http-code-401', () => {
    /* Force login. */
    appModel.clearSystemInfo();
  });

  /* HTTP watch dog handling */
  // watchdog.init();
  // $rootScope.$on('watchdog', (event, parameters) => {
  //   switch(parameters.type) {
  //     case 'http-inactive':
  //       appModel.setOperationMode('fallback', 'watchdog');
  //       break;
  //   }
  // });

  $rootScope.$on('systemRequests', (event, requests) => {
    requests.forEach(request => {
      switch(request.type) {
        case 'restart':
        $state.reload();
        break;
        case 'debugMode':
        appModel.setDebugMode(request.mode)
        break;
        case 'operationMode':
        appModel.setOperationMode(request.mode, 'systemRequest');
        break;
      }
    });
  });
}



// WEBPACK FOOTER //
// ./client/app/index.run.js